<template>
    <div v-if="ready && product != null" class="lazy-product-card flex flex-1">
        <product-card class="flex-1" :variants="product.variants" :title="product.name" :description="product.introduction && product.introduction != '' ? product.introduction : product.description" :is-top="product.is_top" :media="product.media" :link="`${$root.productUrl}/${product.slug}`"></product-card>
    </div>
</template>

<script>
import lazyProduct from '@mixins/components/lazy-product';

export default {
    name: 'Cards.LazyProductCard',

    mixins: [lazyProduct],
};
</script>
